/* eslint-disable no-case-declarations */
import Vue from 'vue'

export const LegalCaseTypeMutations = {
  setSelectedLegalCaseTypes (state, value) {
    if (Array.isArray(value)) {
      state.selectedLegalCaseTypes = value
      return
    }

    const lastIndex = state.selectedLegalCaseTypes.length
    Vue.set(state.selectedLegalCaseTypes, lastIndex, value)
  },
}
